/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
 */

var Lajax = (function () {
	'use strict';

	var baseObjectString = 'l-ajax-js', // Used for data attrs and classes
		inlineLoaderClass = 'button--loader', // Used with the button block styles for inline loader
		inlineLoadingClass = 'button--loading',
		ajaxInProgress = false, // Indicates if a call is in progress

		// ----------------------
		// Private methods
		// ----------------------

		_resetApp = function () {
		// Reset ajax state
			ajaxInProgress = false;

			// for other modules
			pubsubEvent.emit('pubsubEvent_ajaxComplete');

			// Re-bind trigger click (and recreate loaders if needed)
			init();
		},

		_updateView = function ($trigger, dataObj) {
		// Check there is content returned
			if (dataObj.content !== undefined) {
				var scrollToElementId = dataObj.scrollto,
					contentMappings = dataObj.content;

				// Iterate over the new content
				$.each(contentMappings, function (mapType, mapData) {
				// allow only specified types of mapping
					if (['replace', 'append', 'update'].indexOf(mapType) > -1) {
						$.each(mapData, function (selector, htmlData) {
							var $el = $(selector);

							if ($el.length) {
								if (mapType === 'replace') {
								// Replace whole element
									$el.replaceWith(htmlData);
								} else if (mapType === 'append') {
								// Append the content
									$el.append(htmlData);
								} else if (mapType === 'update') {
								// Update the content

									// content might be wrapped with the spinner wrapper
									var $spinnerEl = $el.find('.' + baseObjectString + '-inner');

									if ($spinnerEl.length) {
										$spinnerEl.siblings().remove();
										$spinnerEl.parent().append(htmlData);
									} else {
									// Append the content
										$el.html(htmlData);
									}
								}
							}
						});
					}
				});

				// Scroll to the element
				var scrolltoTarget = $(scrollToElementId);
				if (scrolltoTarget !== undefined && scrolltoTarget.length) {
					var scrolltoTargetLink = scrolltoTarget.find('a');

					// focus the first link inside the scrollToTarget
					if (scrolltoTargetLink.length) {
						scrolltoTargetLink.focus();
					}

					if (scrolltoTarget.offset()) {
						scrolltoTarget = scrolltoTarget.length ? scrolltoTarget : $('[name=' + this.hash.slice(1) + ']');
						$('html, body').animate({
							scrollTop: scrolltoTarget.offset().top
						}, 500);
					}
				}

				// Update numresults on process pages
				_updateProcessNumresults();
			} else {
			// Backend error
				$trigger.after('<p>There seems to be a problem with this action. Please try again later.</p>');
			}

			// Remove the loader
			_setLoadingState($trigger, false);

			// Reset
			_resetApp();

		// Log the data
		// console.log(dataObj)
		},

		_setLoadingState = function ($trigger, state) {
		// Get all the items requiring a loader
			var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

			$.each(loaderItems, function (index, el) {
			// Add the loader
				if (state === true) {
					window.requestAnimationFrame(function () {
					// Conditional to see if its a button or not
						if ($(el).is('button, input, a')) {
							$(el).addClass(inlineLoadingClass);
						} else {
							$(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout');
							$(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--in');
						}

						// Get the ajaxed data
						_getAjaxData($trigger);
					});
				} else if (state === false) {
				// remove the loader (if still present)
					window.requestAnimationFrame(function () {
						if ($(el).length) {
							if ($(el).is('button, input, a')) {
								$(el).removeClass(inlineLoadingClass);

								// Reset
								_resetApp();
							} else {
								$(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--out');

								$(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout').on('transitionend.ajaxout', function (event) {
									$(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--in');
									$(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--out');

									// Reset
									_resetApp();
								});
							}
						}
					});
				}
			});
		},

		_setPreLoadingState = function ($trigger) {
		// Get all the items requiring a loader
			var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

			// Set to loadable content
			$.each(loaderItems, function (index, el) {
				if ($(el).is('button, input, a')) {
					if (!$(el).hasClass(inlineLoaderClass)) {
						$(el).addClass(inlineLoaderClass);
					}
				} else {
					if ($(el).find('.' + baseObjectString).length === 0) {
						$(el).wrapInner('<div class="' + baseObjectString + '"></div>');
						$(el).find('.' + baseObjectString).prepend('<div class="' + baseObjectString + '-inner"></div>');
					}
				}
			});
		},

		_getAjaxData = function ($trigger) {
			var actionURL,
				submitData;

			if ($trigger.is('[type="submit"]')) {
				var $form = $trigger.parents('form');
				// Form action and data
				actionURL = $form.attr('action');
				submitData = $form.serialize();
			} else {
			// For a regular link or button ust use the href
				actionURL = $trigger.attr('href');
				submitData = '';
			}

			// Timed out so no jumpy changes
			setTimeout(function () {
				$.ajax({
					url: actionURL,
					type: 'GET',
					dataType: 'json',
					data: submitData,
					encode: true,
					cache: false
				})
					.done(function (resultObj) {
						var stateURL = actionURL + (submitData ? ('?' + submitData) : ''),
							stateObj = {
								stateURL: stateURL
							},
							ga = window[window.GoogleAnalyticsObject || 'ga'];

						window.history.pushState(stateObj, '', stateURL);

						if (typeof ga === 'function') {
							ga('send', 'pageview', stateURL);
						}

						// Update the content

						_updateView($trigger, resultObj);
					})
					.fail(function (e) {
						$trigger.after('<p>There seems to be a problem triggering this action. Please try again later.</p>');
					});
			}, 500);
		},

		// Handle using the back button
		_popState = function () {
			window.addEventListener('popstate', function (e) {
			// Make sure Safari (ios8) popstate isnt triggered when the page is loaded
				var popStatus = Cookies.get('prevPopped');

				// Has the cookie been set
				if (popStatus !== null) {
				// Is it not the same as the current page
					if (popStatus !== window.location.href) {
						Cookies.set('prevPopped', window.location.href);
						location.reload();
					}
				}
			});
		},

		_bindTriggerClick = function () {
			var $triggers = $('[data-' + baseObjectString + '-trigger]');

			// if a trigger exists
			if ($triggers.length) {
				$triggers.each(function (index, el) {
					var thisTrigger = $(this);

					thisTrigger.off('click.ajax').on('click.ajax', function (e) {
						e.preventDefault();
						// Prevent multiple requests
						if (ajaxInProgress === false) {
						// Set in progress
							ajaxInProgress = true;

							_setLoadingState(thisTrigger, true);
						}
					});
				});
			}
		},

		_updateProcessNumresults = function () {
			if ($('.processlist').length > 0) {
				$('.js-listing-numshowing').html(($('.processlist-item').length));
			}
		},

		// ----------------------
		// Public methods
		// ----------------------

		init = function () {
			var $triggers = $('[data-' + baseObjectString + '-trigger]');

			// if a trigger exists
			if ($triggers.length) {
				$triggers.each(function (index, el) {
					var thisTrigger = $(this);

					// Add class to prepare for loaders
					_setPreLoadingState(thisTrigger);
				});

				_bindTriggerClick();
				// Setup popstate for history API
				_popState();
			}
		};

	// Expose objects here
	return {
		init: init
	};
})();
